<div class="container-fluid ptCustom">

    <div class="my-2">
        <a [routerLink]="['/admin-portal/member/invoice-management']" class="text-white"><i
                class="fa-regular fa-angle-left"></i> back to all invoices</a>
    </div>

    <div class="row">

        <div class="col-xl-8 col-lg-7 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>Paying {{invoices.length}} Invoices</h4>
                        </div>
                        <div *ngFor="let invoice of invoices" class="detailsSection mb-3">
                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Invoice Date</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{invoice.invoiceDateString}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Due Date</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{invoice.dueDateString}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Invoice #</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>{{invoice.name}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel text-end">
                                            <span>Amount</span>
                                        </div>
                                        <div class="dataOutput text-end">
                                            <span>{{invoice.amountString}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="invoices.length > 1"
                                    class="col-auto d-flex justify-content-end align-items-center">
                                    <a (click)="removeInvoiceFromList(invoice)" href="javascript:void(0);"
                                        class="invoice-danger"><i class="fa-regular fa-trash"></i></a>
                                </div>

                            </div>
                        </div>
                        <div *ngIf="donationActive" class="detailsSection mb-3">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Payment Reason</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span>BAC Donation</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="detailsBlock">
                                        <label for="payAmount" class="form-label">Amount</label>
                                        <input [(ngModel)]="donationAmount" type="number" min="50" class="form-control"
                                            id="payAmount" placeholder="0.00">
                                    </div>
                                </div>
                                <div class="col-auto d-flex justify-content-end align-items-center">
                                    <a (click)="disableDonation()" href="javascript:void(0);" class="invoice-danger"><i
                                            class="fa-regular fa-trash"></i></a>
                                </div>

                            </div>
                        </div>
                        <div class="detailsSection invoiceTotal text-end">
                            <span class="grandTotal">
                                Grand Total
                            </span>
                            <span class="totalAmount">
                                {{grandTotal| currency:'USD':'symbol' }}
                            </span>
                        </div>
                    </div>




                </div>
            </div>
        </div>
        <div class="col-xl-4 col-lg-5 my-2">
            <form [formGroup]="paymentInfoForm">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer invoicePay">
                            <div class="detailsHeader justify-content-center">
                                <div class="w-75 mx-auto">
                                    <h4 class="text-center mb-3">Payment Method</h4>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <div class="btn-group paymentSelect w-100" role="group"
                                                aria-label="Payment Type">
                                                <!-- <input [value]="0" [formControl]="paymentTypeCtrl" [checked]="0"
                                                    type="radio" class="btn-check" name="btnPaymentSelect0"
                                                    id="btnPaymentSelect0" autocomplete="off">
                                                <label class="btn btn-outline-primary" for="btnPaymentSelect1">Stored Payment Profile</label> -->
                                                <input [value]="1" [formControl]="paymentTypeCtrl" [checked]="1"
                                                    type="radio" class="btn-check" name="btnPaymentSelect"
                                                    id="btnPaymentSelect1" autocomplete="off">
                                                <label class="btn btn-outline-primary" for="btnPaymentSelect1">Credit
                                                    Card</label>
                                                <!-- <input [value]="2" [formControl]="paymentTypeCtrl" [checked]="2"
                                                    type="radio" class="btn-check" name="btnPaymentSelect"
                                                    id="btnPaymentSelect2" autocomplete="off">
                                                <label class="btn btn-outline-primary"
                                                    for="btnPaymentSelect2">eCheck</label> -->
                                            </div>
                                            <div
                                                *ngIf="paymentTypeCtrl.invalid && (paymentTypeCtrl.dirty || paymentTypeCtrl.touched)">
                                                <i class="fas fa-exclamation-circle"></i> This field is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="detailsSection">

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <div class="paymentInputs p-0">
                                            <div *ngIf="paymentType() == 0">
                                                <div class="row">
                                                    <div class="col-xl-5 col-lg-5 mb-3">
                                                        <label for="yourCity" class="form-label">City</label>
                                                        <input formControlName="city" type="text" class="form-control"
                                                            id="yourCity" placeholder="City">
                                                        <div
                                                            *ngIf="cityCtrl.invalid && (cityCtrl.dirty || cityCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-4 col-lg-4 mb-3">
                                                        <label for="yourState" class="form-label">State</label>
                                                        <select formControlName="state" class="form-select"
                                                            aria-label="state">
                                                            <option selected>Select</option>
                                                            <option value="AL">Alabama</option>
                                                            <option value="AK">Alaska</option>
                                                            <option value="AZ">Arizona</option>
                                                            <option value="AR">Arkansas</option>
                                                            <option value="CA">California</option>
                                                            <option value="CO">Colorado</option>
                                                            <option value="CT">Connecticut</option>
                                                            <option value="DE">Delaware</option>
                                                            <option value="DC">District Of Columbia</option>
                                                            <option value="FL">Florida</option>
                                                            <option value="GA">Georgia</option>
                                                            <option value="HI">Hawaii</option>
                                                            <option value="ID">Idaho</option>
                                                            <option value="IL">Illinois</option>
                                                            <option value="IN">Indiana</option>
                                                            <option value="IA">Iowa</option>
                                                            <option value="KS">Kansas</option>
                                                            <option value="KY">Kentucky</option>
                                                            <option value="LA">Louisiana</option>
                                                            <option value="ME">Maine</option>
                                                            <option value="MD">Maryland</option>
                                                            <option value="MA">Massachusetts</option>
                                                            <option value="MI">Michigan</option>
                                                            <option value="MN">Minnesota</option>
                                                            <option value="MS">Mississippi</option>
                                                            <option value="MO">Missouri</option>
                                                            <option value="MT">Montana</option>
                                                            <option value="NE">Nebraska</option>
                                                            <option value="NV">Nevada</option>
                                                            <option value="NH">New Hampshire</option>
                                                            <option value="NJ">New Jersey</option>
                                                            <option value="NM">New Mexico</option>
                                                            <option value="NY">New York</option>
                                                            <option value="NC">North Carolina</option>
                                                            <option value="ND">North Dakota</option>
                                                            <option value="OH">Ohio</option>
                                                            <option value="OK">Oklahoma</option>
                                                            <option value="OR">Oregon</option>
                                                            <option value="PA">Pennsylvania</option>
                                                            <option value="RI">Rhode Island</option>
                                                            <option value="SC">South Carolina</option>
                                                            <option value="SD">South Dakota</option>
                                                            <option value="TN">Tennessee</option>
                                                            <option value="TX">Texas</option>
                                                            <option value="UT">Utah</option>
                                                            <option value="VT">Vermont</option>
                                                            <option value="VA">Virginia</option>
                                                            <option value="WA">Washington</option>
                                                            <option value="WV">West Virginia</option>
                                                            <option value="WI">Wisconsin</option>
                                                            <option value="WY">Wyoming</option>
                                                        </select>
                                                        <div
                                                            *ngIf="stateCtrl.invalid && (stateCtrl.dirty || stateCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-3 mb-3">
                                                        <label for="yourZip" class="form-label">ZIP</label>
                                                        <input formControlName="zip" type="text" class="form-control"
                                                            id="yourZip" placeholder="ZIP" mask="00000">
                                                        <div
                                                            *ngIf="zipCtrl.invalid && (zipCtrl.dirty || zipCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- show if credit card, otherwise class hides -->
                                            <div *ngIf="paymentType() == 1">
                                                <div class="row">
                                                    <div class="col-12 mb-3">
                                                        <label for="cardNo" class="form-label">Name on Card</label>
                                                        <input formControlName="nameOnCard" type="text"
                                                            class="form-control" id="nameOnCard"
                                                            placeholder="Name on card">
                                                        <div
                                                            *ngIf="nameOnCardCtrl.invalid && (nameOnCardCtrl.dirty || nameOnCardCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-12 mb-3">
                                                        <label for="cardNo" class="form-label">Card Number</label>
                                                        <input formControlName="cardNumber" type="text"
                                                            class="form-control" id="cardNo" placeholder="Card Number"
                                                            minlength="13" maxlength="16">
                                                        <div
                                                            *ngIf="cardNumberCtrl.invalid && (cardNumberCtrl.dirty || cardNumberCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-7 mb-3">
                                                        <label for="cardExp" class="form-label">Expiration</label>
                                                        <input formControlName="cardExpiration" type="text" mask="00/00"
                                                            class="form-control" id="cardExp" placeholder="MM/YY">
                                                        <div
                                                            *ngIf="cardExpirationCtrl.invalid && (cardExpirationCtrl.dirty || cardExpirationCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-5 mb-3">
                                                        <label for="cardCVV" class="form-label">CVV</label>
                                                        <input formControlName="cvv" type="text" class="form-control"
                                                            id="cardCVV" placeholder="CVV" minlength="3" maxlength="4">
                                                        <div
                                                            *ngIf="CVVCtrl.invalid && (CVVCtrl.dirty || CVVCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row align-items-end">
                                                    <div class="col-lg-7 mb-3">
                                                        <label for="yourAddress" class="form-label">Address</label>
                                                        <input formControlName="street" type="text" class="form-control"
                                                            id="yourAddress" placeholder="Address">
                                                        <div
                                                            *ngIf="streetCtrl.invalid && (streetCtrl.dirty || streetCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-5 mb-3">
                                                        <label for="yourAddress2" class="form-label">Apt/Suite <small
                                                                class="fst-italic fw-normal text-muted">(optional)</small></label>
                                                        <input formControlName="street2" type="text"
                                                            class="form-control" id="yourAddress2" placeholder="#">

                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-xl-5 col-lg-5 mb-3">
                                                        <label for="yourCity" class="form-label">City</label>
                                                        <input formControlName="city" type="text" class="form-control"
                                                            id="yourCity" placeholder="City">
                                                        <div
                                                            *ngIf="cityCtrl.invalid && (cityCtrl.dirty || cityCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-4 col-lg-4 mb-3">
                                                        <label for="yourState" class="form-label">State</label>
                                                        <select formControlName="state" class="form-select"
                                                            aria-label="state">
                                                            <option selected>Select</option>
                                                            <option value="AL">Alabama</option>
                                                            <option value="AK">Alaska</option>
                                                            <option value="AZ">Arizona</option>
                                                            <option value="AR">Arkansas</option>
                                                            <option value="CA">California</option>
                                                            <option value="CO">Colorado</option>
                                                            <option value="CT">Connecticut</option>
                                                            <option value="DE">Delaware</option>
                                                            <option value="DC">District Of Columbia</option>
                                                            <option value="FL">Florida</option>
                                                            <option value="GA">Georgia</option>
                                                            <option value="HI">Hawaii</option>
                                                            <option value="ID">Idaho</option>
                                                            <option value="IL">Illinois</option>
                                                            <option value="IN">Indiana</option>
                                                            <option value="IA">Iowa</option>
                                                            <option value="KS">Kansas</option>
                                                            <option value="KY">Kentucky</option>
                                                            <option value="LA">Louisiana</option>
                                                            <option value="ME">Maine</option>
                                                            <option value="MD">Maryland</option>
                                                            <option value="MA">Massachusetts</option>
                                                            <option value="MI">Michigan</option>
                                                            <option value="MN">Minnesota</option>
                                                            <option value="MS">Mississippi</option>
                                                            <option value="MO">Missouri</option>
                                                            <option value="MT">Montana</option>
                                                            <option value="NE">Nebraska</option>
                                                            <option value="NV">Nevada</option>
                                                            <option value="NH">New Hampshire</option>
                                                            <option value="NJ">New Jersey</option>
                                                            <option value="NM">New Mexico</option>
                                                            <option value="NY">New York</option>
                                                            <option value="NC">North Carolina</option>
                                                            <option value="ND">North Dakota</option>
                                                            <option value="OH">Ohio</option>
                                                            <option value="OK">Oklahoma</option>
                                                            <option value="OR">Oregon</option>
                                                            <option value="PA">Pennsylvania</option>
                                                            <option value="RI">Rhode Island</option>
                                                            <option value="SC">South Carolina</option>
                                                            <option value="SD">South Dakota</option>
                                                            <option value="TN">Tennessee</option>
                                                            <option value="TX">Texas</option>
                                                            <option value="UT">Utah</option>
                                                            <option value="VT">Vermont</option>
                                                            <option value="VA">Virginia</option>
                                                            <option value="WA">Washington</option>
                                                            <option value="WV">West Virginia</option>
                                                            <option value="WI">Wisconsin</option>
                                                            <option value="WY">Wyoming</option>
                                                        </select>
                                                        <div
                                                            *ngIf="stateCtrl.invalid && (stateCtrl.dirty || stateCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-3 mb-3">
                                                        <label for="yourZip" class="form-label">ZIP</label>
                                                        <input formControlName="zip" type="text" class="form-control"
                                                            id="yourZip" placeholder="ZIP" mask="00000">
                                                        <div
                                                            *ngIf="zipCtrl.invalid && (zipCtrl.dirty || zipCtrl.touched)">
                                                            <i class="fas fa-exclamation-circle"></i> This field is
                                                            required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- show if ach, otherwise class d-none hides -->
                                            <div *ngIf="paymentType() == 2" class="row align-items-end">
                                                <div class="col-12 mb-3">
                                                    <div class="eCheckImg">
                                                        <img class="w-100 rounded"
                                                            src="../../../assets/images/echeck.jpg" alt="echeck" />
                                                    </div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label for="accountName" class="form-label">Name on Account</label>
                                                    <input formControlName="accountName" type="text"
                                                        class="form-control" id="routeNumber"
                                                        placeholder="Name on Account">
                                                    <div
                                                        *ngIf="accountNameCtrl.invalid && (accountNameCtrl.dirty || accountNameCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label for="routingNo" class="form-label">Routing Number</label>
                                                    <input formControlName="routingNumber" type="text"
                                                        class="form-control" id="routeNumber"
                                                        placeholder="Routing Number" minlength="9" maxlength="9">
                                                    <div
                                                        *ngIf="routingNumberCtrl.invalid && (routingNumberCtrl.dirty || routingNumberCtrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is required
                                                        and must be 9 digits.
                                                    </div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label for="accountNo" class="form-label">Account Number</label>
                                                    <input formControlName="accountNumber1" type="text"
                                                        class="form-control" id="accNumber1"
                                                        placeholder="Account Number" minlength="5" maxlength="17">
                                                    <div
                                                        *ngIf="accountNumber1Ctrl.invalid && (accountNumber1Ctrl.dirty || accountNumber1Ctrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                    <div *ngIf="accountNumbersMatchError">
                                                        <i class="fas fa-exclamation-circle"></i> Account numbers do not
                                                        match.
                                                    </div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label for="accountNo2" class="form-label">Confirm Account
                                                        Number</label>
                                                    <input formControlName="accountNumber2" type="text"
                                                        class="form-control" id="accNumber2"
                                                        placeholder="Confirm Account Number" minlength="5"
                                                        maxlength="17">
                                                    <div
                                                        *ngIf="accountNumber2Ctrl.invalid && (accountNumber2Ctrl.dirty || accountNumber2Ctrl.touched)">
                                                        <i class="fas fa-exclamation-circle"></i> This field is
                                                        required.
                                                    </div>
                                                    <div *ngIf="accountNumbersMatchError">
                                                        <i class="fas fa-exclamation-circle"></i> Account numbers do not
                                                        match.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="">
                                    <a (click)="submitPayment()" href="javascript:void(0);" type="button"
                                        class="btn btn-add btn-lg text-strong hvr-grow w-100">Pay {{grandTotal|
                                        currency:'USD':'symbol' }} <i class="fa-solid fa-arrow-right"></i></a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>

    </div>

</div>